import { get, reduce, set } from "lodash"
import { createSelector } from "reselect"

const getRawFavorites = state => get(state, "global.data.userFavoriteResources.data.0.value")
export const getFavorites = createSelector(
  [getRawFavorites],
  (favorites) => reduce(favorites, (acc, favorite) => set(acc, favorite.resourceId, true), {}),
)
